module.exports = "/assets/data/3f2643b29d03ecc40db682494a70e2ba-SW9.data.json";